import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import { type Task, task } from 'ember-concurrency';
import type MarketPerformanceDataItem from 'lumen/models/market-performance/data-item';
import type { HotelAndMarketServiceWithMarket } from 'lumen/services/hotel-and-market';
import { APIGATEWAY } from 'lumen/utils/constants/general-constants';
import protectedRoute from 'lumen/utils/decorators/protected-route';
import SilentTaskError, {
  getErrorMessage,
} from 'lumen/utils/silent-task-error';

type Model = {
  loadSnapshotsTask: Task<MarketPerformanceDataItem[], []>;
};

// @ts-expect-error: Unable to resolve signature of class decorator when called as an expression.
@protectedRoute({
  features: ['reservations.market.overview'],
})
export default class MarketSnapshotsOverviewRoute extends Route {
  @service declare alerting: Services['alerting'];
  @service declare errorTracking: Services['error-tracking'];
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithMarket;
  @service declare store: Services['store'];

  loadSnapshotsTask = task({ restartable: true }, async () => {
    try {
      return await this.store.query<MarketPerformanceDataItem>(
        'market-performance/data-item',
        {
          namespace: APIGATEWAY,
          typeKey: `reservations/market/${this.hotelAndMarketService.market.id}`,
          view: 'overview',
          include: 'otb',
          group_by: 'property',
          start_date: '2026-01-01',
          end_date: '2026-12-31',
          market_id: this.hotelAndMarketService.market.id,
        },
      );
    } catch (error) {
      void this.alerting.showErrorAlert();
      this.errorTracking.captureException(error);

      throw new SilentTaskError(getErrorMessage(error));
    }
  });

  model(): Model {
    void this.loadSnapshotsTask.perform();

    return {
      loadSnapshotsTask: this.loadSnapshotsTask,
    };
  }
}
